import { render, staticRenderFns } from "./inventaris.vue?vue&type=template&id=79ce6cb8&scoped=true&"
import script from "./inventaris.vue?vue&type=script&lang=js&"
export * from "./inventaris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ce6cb8",
  null
  
)

export default component.exports